import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GA4ConnectionStatus } from '../types/ga4.types';

interface GA4State extends GA4ConnectionStatus {
  setGA4Status: (status: Partial<GA4ConnectionStatus>) => void;
  clearGA4Status: () => void;
}

export const useGA4Store = create<GA4State>()(
  persist(
    (set) => ({
      connected: false,
      propertyId: undefined,
      conversionEventsCount: 0,
      lastSyncedAt: undefined,
      setGA4Status: (status) =>
        set((state) => ({
          ...state,
          ...status,
        })),
      clearGA4Status: () =>
        set({
          connected: false,
          propertyId: undefined,
          conversionEventsCount: 0,
          lastSyncedAt: undefined,
        }),
    }),
    {
      name: 'ga4-storage',
    }
  )
);
